<ul class="breadcrumb">
  <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li><a [routerLink]="['/companies']">Empresas</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li [hidden]="company.id==null"><a [routerLink]="['/companies', company.id]">{{company.name}}</a></li>
  <li [hidden]="company.id!=null">Nueva empresa</li>
</ul>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>
<form #formDetails="ngForm">
    <p-card header="Detalles">
        <div class="p-grid">
            <div class="p-col p-field">
                <label for="name">Nombre</label>
                <input name="name" type="text" pInputText [(ngModel)]="company.name" />
            </div>
            <div class="p-col-4 p-field">
                <label for="vat_number">CIF</label>
                <input name="vat_number" type="text" pInputText [(ngModel)]="company.vat_number" />
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12 p-field">
                <label for="address">Dirección</label>
                <input name="address" type="text" pInputText [(ngModel)]="company.address" />
            </div>
            <div class="p-col-4 p-field">
                <label for="country_id">País</label>
                <p-dropdown name="country_id" [options]="countries" [(ngModel)]="company.country_id" optionValue="id" optionLabel="name" placeholder="Selecciona un país" [showClear]="true" appendTo="body"></p-dropdown>
            </div>
            <div class="p-col-4 p-field">
                <label for="city">Ciudad</label>
                <input name="city" type="text" pInputText [(ngModel)]="company.city" />
            </div>
            <div class="p-col-4 p-field">
                <label for="postal_code">Cód. Postal</label>
                <input name="postal_code" type="text" pInputText [(ngModel)]="company.postal_code" />
            </div>
            <div class="p-col-3 p-field">
                <label for="phone_1">Teléfono 1</label>
                <input name="phone_1" type="text" pInputText [(ngModel)]="company.phone_1" />
            </div>
            <div class="p-col-3 p-field">
                <label for="phone_2">Teléfono 2</label>
                <input name="phone_2" type="text" pInputText [(ngModel)]="company.phone_2" />
            </div>
            <div class="p-col-6 p-field">
                <label for="email">Email</label>
                <input name="email" type="text" pInputText [(ngModel)]="company.email" />
            </div>
        </div>
        <ng-template pTemplate="footer">
            <div class="p-d-flex">
                <p-button label="Borrar" *ngIf="company.id != 0" icon="pi pi-trash" styleClass="p-button-danger" (click)="delete()"></p-button>
                <div class="flex-grow-1"></div>
                <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary p-button-text" (click)="cancel()"></p-button>
                <p-button label="Guardar" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
            </div>
        </ng-template>
    </p-card>
</form>
